import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { BROKERS_ROUTES } from "app/brokers/brokers.routing";
import { BrokersService } from 'app/brokers/services/brokers.service';
import { BrokersListComponent } from 'app/brokers/component/brokers-list/brokers-list.component';
import { CoreModule } from 'app/core/core.module';
import { BrokersAddComponent } from 'app/brokers/component/brokers-add/brokers-add.component';

@NgModule({
	imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(BROKERS_ROUTES)
	],
    declarations: [
        BrokersListComponent,
        BrokersAddComponent
    ],
    providers: [BrokersService]
})
export class BrokersModule { }
